import { Configuration, LogLevel, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID!,
        authority: process.env.REACT_APP_MSAL_AUTHORITY,
        redirectUri: "/",
        postLogoutRedirectUri: "/",
    
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        loggerOptions: {
            logLevel: LogLevel.Warning,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    },
    cache: {
        cacheLocation: "localStorage",  // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

/**
 * Required scopes
 */
export const loginRequest: PopupRequest = {
    scopes: process.env.REACT_APP_MSAL_SCOPES!.split(',')
};

export const groupAccess = {
    admin: process.env.REACT_APP_GROUP_ADMIN_ID!,
    arbetsledning: process.env.REACT_APP_GROUP_ARBETSLEDNING_ID!,
    worker: process.env.REACT_APP_GROUP_WORKER_ID!,
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",    
};

/**
 * IMPORTANT: In case of overage, group list is cached for 1 hr by default, and thus cached groups 
 * will miss any changes to a users group membership for this duration. For capturing real-time 
 * changes to a user's group membership, consider implementing Microsoft Graph change notifications. 
 * For more information, visit: https://learn.microsoft.com/graph/api/resources/webhooks
 */
export const CACHE_TTL_IN_MS = 60 * 60 * 1000; // 1 hour in milliseconds 